// ReorderInfo.styles.ts
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  max-width: 320px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : 'white')};
  border-radius: 6px;
`;

export const Title = styled.h3`
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1a1a1a')};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #1a4d4d;
  margin-top: 2px;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#4a4a4a')};

  strong {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1a1a1a')};
    font-weight: 300;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e8e8e8')};
  margin: 4px 0;
`;

export const TipSection = styled.div`
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f5f7fa')};
  padding: 12px;
  border-radius: 6px;
  margin-top: 4px;
`;

export const TipTitle = styled.div`
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1a1a1a')};
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    color: #1a4d4d;
  }
`;

export const TipText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b6b6b')};
`;

export const SecondaryButton = styled.button`
  padding: 12px 20px;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : 'white')};
  justify-content: center;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#475569')};
  border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#dcdfe4')};
  border-radius: 6px;
  font-size: 15px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s;

  &:hover {
    border-color: #1a4d4d;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e6f2f2')};
  }
`;
